import { FileText, X } from 'lucide-react'
import { Button } from '@/components/ui'
import { cn } from '@/lib/utils'
import { formatFileSize } from '@/utils/tool-management/excel-file.util'

interface UploadedFileDisplayProps {
  file: File
  uploadProgress: number
  onRemove: () => void
  fileSizeUnit: string
  error?: string
  onRetry?: () => void
}

export function UploadedFileDisplay({
  file,
  uploadProgress,
  onRemove,
  fileSizeUnit,
  error,
  onRetry,
}: UploadedFileDisplayProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between p-3 rounded-lg border',
        error ? 'border-red-500 bg-white' : 'border-transparent bg-gray-50'
      )}
    >
      <div className='flex items-center space-x-3'>
        <div className='flex items-center justify-center h-10 w-10 rounded-lg bg-gray-100'>
          <FileText className='h-5 w-5 text-gray-500' />
        </div>
        <div>
          <p className='text-sm font-medium text-gray-900'>{file.name}</p>
          {error ? (
            <p className='text-xs text-red-600'>{error}</p>
          ) : (
            <p className='text-xs text-gray-500'>
              {formatFileSize(file.size)} {fileSizeUnit}
            </p>
          )}
        </div>
      </div>

      <div className='flex items-center space-x-3'>
        {uploadProgress > 0 && uploadProgress < 100 && !error && (
          <span className='text-xs text-gray-500'>{uploadProgress}%</span>
        )}

        {error && onRetry && (
          <Button
            variant='outline'
            size='sm'
            className='h-8 px-3 text-blue-600 border-blue-200 hover:bg-blue-50 hover:text-blue-700'
            onClick={onRetry}
          >
            Retry
          </Button>
        )}

        <button
          type='button'
          className='text-gray-400 hover:text-gray-600 transition-colors'
          onClick={onRemove}
        >
          <X className='h-5 w-5' />
        </button>
      </div>
    </div>
  )
}
